import React from 'react';
import { HiX, HiOutlineChatAlt2 } from 'react-icons/hi';

function WhatsAppModal({ onClose }) {
    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center px-4 md:px-0">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={onClose}></div>
            
            {/* Modal Content */}
            <div className="relative bg-white rounded-[3rem] p-10 md:p-14 max-w-lg w-full shadow-[0_50px_100px_-20px_rgba(0,0,0,0.5)] transform animate-scale-up z-10 overflow-hidden text-center space-y-8 border border-white/20">
                {/* Decorative Elements */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full -translate-y-1/2 translate-x-1/2 -z-10 blur-2xl"></div>
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary/5 rounded-full translate-y-1/2 -translate-x-1/2 -z-10 blur-2xl"></div>

                <button 
                    className="absolute top-6 right-6 w-12 h-12 rounded-full flex items-center justify-center text-muted-foreground hover:bg-secondary hover:text-foreground transition-all"
                    onClick={onClose}
                >
                    <HiX size={24} />
                </button>

                <div className="space-y-6">
                    <div className="w-20 h-20 bg-primary/10 rounded-[2.5rem] flex items-center justify-center text-primary mx-auto animate-float">
                        <HiOutlineChatAlt2 size={40} />
                    </div>
                    
                    <div className="space-y-3">
                        <span className="text-[10px] font-black uppercase tracking-[0.3em] text-primary">Future Connection</span>
                        <h2 className="text-3xl font-heading font-black text-foreground">
                            Concierge <span className="text-primary italic">WhatsApp</span>
                        </h2>
                    </div>

                    <div className="space-y-4 text-muted-foreground font-medium text-sm leading-relaxed">
                        <p>
                            We are currently engineering a bespoke 24/7 concierge experience via WhatsApp to serve your hygiene needs better.
                        </p>
                        <p className="bg-secondary/50 p-4 rounded-2xl italic">
                            "Direct access to our premium specialists, scheduling updates, and exclusive membership offers."
                        </p>
                    </div>

                    <button 
                        className="btn-primary w-full !py-5 uppercase tracking-[0.2em] text-xs font-black shadow-lg shadow-primary/20"
                        onClick={onClose}
                    >
                        Notify me on launch
                    </button>
                    
                    <p className="text-[10px] uppercase font-black tracking-widest text-muted-foreground pt-4">
                        Quality Hospitality • Since 2024
                    </p>
                </div>
            </div>
        </div>
    );
}

export default WhatsAppModal;

